/*
#############################################################################
# Copyright (c) 2022-2023 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
#
# NVIDIA CORPORATION, its affiliates and licensors retain all intellectual
# property and proprietary rights in and to this material, related
# documentation and any modifications thereto. Any use, reproduction,
# disclosure or distribution of this material and related documentation
# without an express license agreement from NVIDIA CORPORATION or
# its affiliates is strictly prohibited.
###############################################################################
*/

import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import FilteredItemList from "../features/filtered-items/FilteredItemList";
import { getContentHeight } from "../utils/utils";

function SpeechMenu() {
  const [menuHeight, setMenuHeight] = useState();

  const handleWindowSizeChange = () => {
    setMenuHeight(getContentHeight());
  };

  const FilteredItemStyle = {
    overflow: "auto",
    display: "flex",
    maxHeight: menuHeight,
    paddingLeft: 10,
    paddingRight: 10,
  };

  useEffect(() => {
    handleWindowSizeChange();
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  return (
    <Grid
      container
      direction='row'
      justifyContent='center'
      alignItems='center'
      sx={FilteredItemStyle}
    >
      <FilteredItemList />
    </Grid>
  );
}

export default SpeechMenu;
